/* eslint-disable import/extensions */
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useIsMobile } from "@hotelise/ui";

import {
	ReservationsList,
	ReservationDetailsPanel,
	FiltersPanel,
} from "components/organisms";
import { ReservationsSummary, PageHeader } from "components/molecules";

import {
	getReservations,
	getReservationsList,
	getReservationsLoading,
} from "state/modules/reservations";

import { ReportTableItemWithTransfer } from "interfaces/reports";

const ReservationsPage = (): JSX.Element => {
	const [selectedReservation, setSelectedReservation] =
		useState<ReportTableItemWithTransfer | null>(null);

	const dispatch = useDispatch();
	const isMobile = useIsMobile();

	const reservations = useSelector(getReservationsList);
	const isLoading = useSelector(getReservationsLoading);

	useEffect(() => {
		dispatch(getReservations());
	}, [dispatch]);

	const handleSelectReservation = (
		item: ReportTableItemWithTransfer | null
	) => {
		setSelectedReservation(item);
	};

	return (
		<div className="w-full h-screen overflow-auto relative bg-background sm:pb-24 md:h-auto md:min-h-screen" id="reservationsListContainer">
			<PageHeader
				title="Reservations"
				description="View all reservations across your properties in one place."
			/>
			<FiltersPanel isMobile={isMobile} />
			<div className="pt-2">
				<ReservationsSummary isLoading={isLoading} isMobile={isMobile} />
			</div>
			<div className="pt-2">
				<ReservationsList
					showProperty
					reservations={reservations}
					isLoading={isLoading}
					onSelect={handleSelectReservation}
					isMobile={isMobile}
				/>
			</div>
			<ReservationDetailsPanel
				reservation={selectedReservation}
				open={!!selectedReservation}
				onOpenChange={(open) => {
					if (!open) setSelectedReservation(null);
				}}
			/>
		</div>
	);
};

export default ReservationsPage;
